module.exports = __webpack_public_path__ + "static/media/reception-5.96ca7f0f.jpg";